import * as actionTypes from '../types/documents';

const initialState = {
  error: false,
  loading: false,
  actLoading: false,
  pieceLoading: false,
  holderReportsLoading: false,
  number: null,
  actNumbers: [],
  actsByStock: [],
  piecesByAct: [],
  piecesByStock: [],
  holderReportsByStock: [],
  actUpdate: {
    okRequest: false,
    loading: false
  },
  actDelete: {
    okRequest: false,
    loading: false
  },
  actsSign: {
    okRequest: false,
    loading: false
  },
  addPiece: {
    okRequest: false,
    loading: false
  },
  deletePiece: {
    okRequest: false,
    loading: false
  },
  reportDelete: {
    okRequest: false,
    loading: false
  },
  okUpdate: false,
  visiblePopupSignSelected: false,
  selectedDocItems: []
};

const reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case actionTypes.GET_ADMIN_ACT_UPDATE:
      return {
        ...state,
        okUpdate: true
      };

    case actionTypes.GET_DOCUMENTS_NEXT_NUMBER:
      return {
        ...state,
        error: false,
        loading: true,
        number: null
      };
    case actionTypes.GET_DOCUMENTS_NEXT_NUMBER_SUCCESS:
      return {
        ...state,
        loading: false,
        number: payload
      };
    case actionTypes.GET_DOCUMENTS_NEXT_NUMBER_FAIL:
      return {
        ...state,
        error: true,
        loading: false
      };
    case actionTypes.GET_ACTS_BY_DOCTYPE_SUCCESS:
      return {
        ...state,
        actNumbers: payload
      };
    case actionTypes.GET_ACTS_BY_DOCTYPE_FAIL:
      return {
        ...state,
        actNumbers: []
      };

    case actionTypes.GET_ACTS_BY_STOCK:
      return {
        ...state,
        actLoading: true,
        okUpdate: false
      };
    case actionTypes.GET_ACTS_BY_STOCK_SUCCESS:
      return {
        ...state,
        actLoading: false,
        actsByStock: payload
      };
    case actionTypes.GET_ACTS_BY_STOCK_FAIL:
      return {
        ...state,
        actLoading: false,
        actsByStock: []
      };

    case actionTypes.GET_PIECES_BY_STOCK:
      return {
        ...state,
        piecesByStock: []
      };
    case actionTypes.GET_PIECES_BY_STOCK_SUCCESS:
      return {
        ...state,
        piecesByStock: payload
      };
    case actionTypes.GET_PIECES_BY_STOCK_FAIL:
      return {
        ...state,
        piecesByStock: []
      };

    case actionTypes.GET_PIECES_BY_ACT:
      return {
        ...state,
        pieceLoading: true
      };
    case actionTypes.GET_PIECES_BY_ACT_SUCCESS:
      return {
        ...state,
        pieceLoading: false,
        piecesByAct: payload
      };
    case actionTypes.GET_PIECES_BY_ACT_FAIL:
      return {
        ...state,
        piecetLoading: false,
        piecesByAct: []
      };

    case actionTypes.ADD_PIECE_TO_ACT:
      return {
        ...state,
        addPiece: {
          okRequest: false,
          loading: true
        }
      };
    case actionTypes.ADD_PIECE_TO_ACT_SUCCESS:
      return {
        ...state,
        addPiece: {
          okRequest: true,
          loading: false
        }
      };
    case actionTypes.ADD_PIECE_TO_ACT_CLEAR:
    case actionTypes.ADD_PIECE_TO_ACT_FAIL:
      return {
        ...state,
        addPiece: {
          okRequest: false,
          loading: false
        }
      };

    case actionTypes.DELETE_PIECE_FROM_ACT:
      return {
        ...state,
        deletePiece: {
          okRequest: false,
          loading: true
        }
      };
    case actionTypes.DELETE_PIECE_FROM_ACT_SUCCESS:
      return {
        ...state,
        deletePiece: {
          okRequest: true,
          loading: false
        }
      };
    case actionTypes.DELETE_PIECE_FROM_ACT_CLEAR:
    case actionTypes.DELETE_PIECE_FROM_ACT_FAIL:
      return {
        ...state,
        deletePiece: {
          okRequest: false,
          loading: false
        }
      };

    case actionTypes.UPDATE_ACT:
      return {
        ...state,
        actUpdate: {
          okRequest: false,
          loading: true
        }
      };
    case actionTypes.UPDATE_ACT_SUCCESS:
      return {
        ...state,
        actUpdate: {
          okRequest: true,
          loading: false
        }
      };
    case actionTypes.UPDATE_ACT_CLEAR:
    case actionTypes.UPDATE_ACT_FAIL:
      return {
        ...state,
        actUpdate: {
          okRequest: false,
          loading: false
        }
      };

    case actionTypes.DELETE_ACT:
      return {
        ...state,
        actDelete: {
          okRequest: false,
          loading: true
        }
      };
    case actionTypes.DELETE_ACT_SUCCESS:
      return {
        ...state,
        actDelete: {
          okRequest: true,
          loading: false
        }
      };
    case actionTypes.DELETE_ACT_CLEAR:
    case actionTypes.DELETE_ACT_FAIL:
      return {
        ...state,
        actDelete: {
          okRequest: false,
          loading: false
        }
      };
    case actionTypes.GET_HOLDER_REPORTS_BY_STOCK:
      return {
        ...state,
        holderReportsLoading: true
      };
    case actionTypes.GET_HOLDER_REPORTS_BY_STOCK_SUCCESS:
      return {
        ...state,
        holderReportsLoading: false,
        holderReportsByStock: payload
      };
    case actionTypes.GET_HOLDER_REPORTS_BY_STOCK_FAIL:
      return {
        ...state,
        holderReportsLoading: false,
        holderReportsByStock: []
      };
    case actionTypes.DELETE_HOLDER_REPORT:
      return {
        ...state,
        reportDelete: {
          okRequest: false,
          loading: true
        }
      };
    case actionTypes.DELETE_HOLDER_REPORT_SUCCESS:
      return {
        ...state,
        reportDelete: {
          okRequest: true,
          loading: false
        }
      };
    case actionTypes.DELETE_HOLDER_REPORT_FAIL:
      return {
        ...state,
        reportDelete: {
          okRequest: false,
          loading: false
        }
      };

    case actionTypes.SIGN_ACTS_BY_CLIENT:
      return {
        ...state,
        actsSign: {
          okRequest: false,
          loading: true
        }
      };

    case actionTypes.SIGN_ACTS_BY_CLIENT_SUCCESS:
      return {
        ...state,
        actsSign: {
          okRequest: true,
          loading: false
        }
      };

    case actionTypes.SIGN_ACTS_BY_CLIENT_FAIL:
      return {
        ...state,
        actsSign: {
          okRequest: false,
          loading: false
        }
      };

    case actionTypes.SET_INITIAL_STATE_ACTS:
      return {
        ...initialState
      };

    case actionTypes.SET_VISIBLE_POPUP_SIGN_SELECTED:
      return {
        ...state,
        visiblePopupSignSelected: payload
      };

    case actionTypes.SET_SELECTED_DOC_ITEMS:
      return {
        ...state,
        selectedDocItems: payload
      };

    default:
      return state;
  }
};

export default reducer;
